import React, { useEffect, useState } from "react";
import { Table, Descriptions, Button, Select, Popconfirm, Space, Card, Input, Form, Tag } from "antd";
import { ProductServices } from "../../Services/ProductServices";
import { navigate } from "../../../navigation";
import { notify } from "../../customs/NotifyProvider";
import { ENDPOINTS } from "../../Services/ENDPOINTS";

const ListVehicle = () => {
    const [data, setData] = useState([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [statusFilter, setStatusFilter] = useState("All");
    const [serviceFilter, setServiceFilter] = useState("All");
    const [rentaltype, setRentalType] = useState("All");

    const filteredData = data
        ?.filter((item) =>
            Object.values(item)
                .join(" ")
                .toLowerCase()
                .includes(searchText.toLowerCase())
        )
        ?.filter((item) =>
            statusFilter === "All" ? true : item.status === statusFilter
        )
        ?.filter((item) =>
            serviceFilter === "All" ? true : item.service_type === serviceFilter
        )
        ?.filter((item) => {
            // Apply rental_type filter only if:
            // 1) Service type is rental
            // 2) rentaltype is not "All"
            if (serviceFilter === "rental" && rentaltype !== "All") {
                return Number(item.rental_type) === Number(rentaltype);
            } else if (serviceFilter === "outstation" && rentaltype !== "All") {
                return item.rental_type === rentaltype;
            }
            return true;
        });



    useEffect(() => {
        fetchCars();
    }, []);

    const fetchCars = async () => {
        try {
            const res = await ProductServices.getAllCarDetialAdmin();

            console.log("**", res);


            const formatted = res.data.map((item, index) => ({
                ...item,
                key: index + 1,
                status: item.status ?? "Active"  // keep existing, else use Active
            }));


            setData(formatted);
        } catch (error) {
            console.error("Error fetching cars:", error);
        }
    };

    const handleEdit = (record) => {
        if (!record?.id) {
            notify.error("Invalid vehicle record", "Missing ID");
            return;
        }

        navigate('/edit-vehicle', { state: { id: record.id } });
    };


    const handleView = (record) => {
        if (expandedRowKeys.includes(record.key)) {
            // already expanded → collapse it
            setExpandedRowKeys([]);
        } else {
            // expand this row
            setExpandedRowKeys([record.key]);
        }
    };


    const handleStatusChange = async (value, record) => {
        const updated = data.map((item) =>
            item.key === record.key ? { ...item, status: value } : item
        );
        setData(updated);
        console.log(value, record?.id);

        const payload = {
            status: value
        }

        const response = await ProductServices.updateCarDetails(record?.id, payload);
        if (response.status) {
            notify.success("sucess", response.message)
        } else {
            notify.error("Something went wrong!", response.message)
        }

    };

    const columns = [
        { title: "S.No", dataIndex: "key", key: "key" },
        { title: "Car Name", dataIndex: "car_name", key: "car_name" },
        {
            title: "Image",
            dataIndex: "upload_img",
            key: "upload_img",
            render: (img) => (
                img ? (
                    <img
                        src={`${ENDPOINTS.cleanBase}${img}`}
                        alt="car"
                        style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 6 }}
                    />
                ) : (
                    "No Image"
                )
            ),
        },
        {
            title: "Service Type",
            dataIndex: "service_type",
            key: "service_type",
            width: 180,
            render: (text, record) => {
                if (text === "rental") {
                    return (
                        <div>
                            <div>{text?.toUpperCase()}</div>
                            <div style={{ fontSize: 14, color: "#3f3f3fff" }}>
                                (Rental Hour: {record.rental_type})
                            </div>
                        </div>
                    );
                }else if(text === "outstation"){
                    return (
                        <Space>
                            <div>{text?.toUpperCase()}</div>

                            <div>
                                
                                {record.rental_type === "premium" ? (
                                    <Tag color="cyan">PREMIUM</Tag>
                                ) : (
                                    <Tag color="blue">REGULAR</Tag>
                                )}
                                
                            </div>
                        </Space>
                    );
                }
                return text?.toUpperCase();
            }
        },

        { title: "Car Type", dataIndex: "car_type", key: "car_type" },
        // { title: "Category", dataIndex: "car_category", key: "car_category" },
        { title: "Base Price", dataIndex: "base_price", key: "base_price" },
        { title: "Display Price", dataIndex: "display_price", key: "display_price" },
        { title: "Discount (%)", dataIndex: "discount_percent", key: "discount_percent" },

        // ⭐ Status Column
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (_, record) => (
                <Select
                    value={record.status}
                    style={{ width: 100 }}
                    onChange={(value) => handleStatusChange(value, record)}
                    options={[
                        { value: "Active", label: "Active" },
                        { value: "Inactive", label: "Inactive" },
                    ]}
                />
            ),
        },

        {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
                <Space>
                    <Button danger onClick={() => handleEdit(record)}>
                        Edit / Delete
                    </Button>



                    <Button onClick={() => handleEdit(record)}>View</Button>
                </Space>
            ),
        },
    ];

    return (
        <Space direction="vertical">

            <>
                <Form layout="vertical">
                    <Space size="large" wrap>

                        <Form.Item label="Search">
                            <Input
                                placeholder="Search..."
                                style={{ width: 300 }}
                                value={searchText}
                                allowClear
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item label="Service Type">
                            <Select
                                value={serviceFilter}
                                style={{ width: 200 }}
                                onChange={(value) => {
                                    setServiceFilter(value)
                                    setRentalType("All")
                                }}
                                options={[
                                    { value: "All", label: "All" },
                                    { value: "rental", label: "Rental" },
                                    { value: "airport", label: "Airport" },
                                    { value: "outstation", label: "Outstation" },
                                ]}
                            />
                        </Form.Item>
                        {serviceFilter === "rental" && (
                            <Form.Item label="Rental Type">
                                <Select
                                    value={rentaltype}
                                    style={{ width: 200 }}
                                    onChange={(value) => setRentalType(value)
                                    }
                                    options={[
                                        { value: "All", label: "All" },
                                        { value: 4, label: "4 Hours" },
                                        { value: 6, label: "6 Hours" },
                                        { value: 8, label: "8 Hours" },
                                        { value: 10, label: "10 Hours" },
                                        { value: 12, label: "12 Hours" },
                                    ]}
                                />
                            </Form.Item>
                        )}

                        {serviceFilter === "outstation" && (
                            <Form.Item label="Drop Type">
                                <Select
                                    value={rentaltype}
                                    style={{ width: 200 }}
                                    onChange={(value) => setRentalType(value)
                                    }
                                    options={[
                                        { value: "All", label: "All" },
                                        { value: 'premium', label: "Premium Drop" },
                                        { value: 'regular', label: "Regular Drop" },
                                        { value: 'round', label: "Round Trip" },
                                    ]}
                                />
                            </Form.Item>
                        )}

                        <Form.Item label="Status">
                            <Select
                                value={statusFilter}
                                style={{ width: 200 }}
                                onChange={(value) => setStatusFilter(value)}
                                options={[
                                    { value: "All", label: "All" },
                                    { value: "Active", label: "Active" },
                                    { value: "Inactive", label: "Inactive" },
                                ]}
                            />
                        </Form.Item>

                    </Space>
                </Form>
            </>



            <Table
                columns={columns}
                dataSource={filteredData}
                pagination={{ pageSize: 10 }}
                expandedRowKeys={expandedRowKeys}
                onExpand={(expanded, record) => {
                    if (expanded) {
                        setExpandedRowKeys([record.key]);
                    } else {
                        setExpandedRowKeys([]);
                    }
                }}

                expandable={{
                    expandedRowRender: (record) => (
                        <Descriptions
                            title={`More Details - ${record.car_name}`}
                            bordered
                            size="small"
                            column={2}
                            style={{ paddingLeft: "50px" }}
                        >
                            <Descriptions.Item label="Car Tags">
                                {record.car_tags || "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Description">
                                {record.description}
                            </Descriptions.Item>

                            <Descriptions.Item label="Min Travel Range (KM)">
                                {record.min_travel_range_km}
                            </Descriptions.Item>

                            <Descriptions.Item label="Additional Travel Amount">
                                {record.additional_travel_amount}
                            </Descriptions.Item>

                            {/* <Descriptions.Item label="Toll & Taxes">
                                {record.toll_and_taxes}
                            </Descriptions.Item> */}

                            {/* <Descriptions.Item label="Driver Allowance Included">
                                {record.driver_allowance_included ? "Yes" : "No"}
                            </Descriptions.Item> */}

                            {/* <Descriptions.Item label="Driver Allowance Amount">
                                {record.driver_allowance_amount}
                            </Descriptions.Item> */}

                            <Descriptions.Item label="New Car Promise">
                                {record.new_car_promise ? "Yes" : "No"}
                            </Descriptions.Item>

                            <Descriptions.Item label="New Car Promise Price">
                                {record.new_car_promise_price}
                            </Descriptions.Item>

                            <Descriptions.Item label="Inclusion">
                                {record.inclusion}
                            </Descriptions.Item>

                            <Descriptions.Item label="Exclusion">
                                {record.exclusion}
                            </Descriptions.Item>

                            <Descriptions.Item label="Rating">
                                {record.rating}
                            </Descriptions.Item>

                            <Descriptions.Item label="Added On">
                                {record.added_on || "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Updated On">
                                {record.updated_on || "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Added By">
                                {record.added_by || "N/A"}
                            </Descriptions.Item>
                        </Descriptions>
                    ),
                    rowExpandable: () => true,
                }}
            />

        </Space>
    );
}
export default ListVehicle;